import { Box, type Theme, styled, useMediaQuery } from "@mui/material";
import * as React from "react";
import { FilterLiveForm, type Identifier, ListClasses, type ListProps, List as RaList, type RaRecord } from "react-admin";
import { FilterAside, asideWidth } from "./filter-aside";

interface FilterListProps extends ListProps {
    top?: React.ReactElement;
    open: boolean;
    onOpen: (open: boolean) => void;
}

const Form = styled("form")({ width: "100%" });

export const List = ({ children, top, aside, open, onOpen, ...rest }: FilterListProps): JSX.Element => {
    const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down("lg"));
    return (
        <Box sx={{ display: "flex", paddingTop: 0.5 }}>
            {/* @ts-expect-error */}
            <StyledList
                {...rest}
                actions={<FilterLiveForm formComponent={Form}>{top}</FilterLiveForm>}
                open={open}
                isSmall={isSmall}
                aside={
                    <FilterAside open={open} onOpen={onOpen} isSmall={isSmall}>
                        {React.Children.map(aside, child => (React.isValidElement(child) ? React.cloneElement(child, { open } as any) : child)) as any}
                    </FilterAside>
                }
                disableSyncWithLocation
                debounce={0}
                empty={false}
            >
                {children}
            </StyledList>
        </Box>
    );
};
type StyledListProps = ListProps<RaRecord<Identifier>> & { theme: Theme; open: boolean; isSmall: boolean };

export const ListStyle = ({ theme, open, isSmall }: StyledListProps) => ({
    flexGrow: 1,
    [`& .${ListClasses.main}`]: {
        "& .MuiToolbar-root": { minHeight: 48 },
        "& .RaBulkActionsToolbar-collapsed": { minHeight: 0 },
        flexGrow: 1,
        paddingTop: theme.spacing(2),
        padding: theme.spacing(1),
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginRight: !isSmall ? -asideWidth : 0,
        ...(open && {
            transition: theme.transitions.create("margin", {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginRight: 0,
        }),
    },
});

const StyledList = styled(RaList, { shouldForwardProp: prop => prop !== "open" })(ListStyle);
